import { render, staticRenderFns } from "./user-add.vue?vue&type=template&id=c9ef01c8&"
import script from "./user-add.vue?vue&type=script&lang=js&"
export * from "./user-add.vue?vue&type=script&lang=js&"
import style0 from "./user-add.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports